export const MIN_AFFIRM_PRICE = 1;
export const MAX_AFFIRM_PRICE = 25000;
